import { render, staticRenderFns } from "./nationality.vue?vue&type=template&id=bb71d384&scoped=true&"
import script from "./nationality.vue?vue&type=script&lang=js&"
export * from "./nationality.vue?vue&type=script&lang=js&"
import style0 from "./nationality.vue?vue&type=style&index=0&id=bb71d384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb71d384",
  null
  
)

export default component.exports